<template>
	<NoLineBreaks v-if="geoFencingRef == null">{{ $t('license.fields.withoutRestrictions') }}</NoLineBreaks>
	<div v-else>
		<NoLineBreaks>{{ $t('license.fields.latitude') }} {{ geoFencingDisplay.bCoord }}</NoLineBreaks>
		<NoLineBreaks>{{ $t('license.fields.longitude') }} {{ geoFencingDisplay.lCoord }}</NoLineBreaks>
		<NoLineBreaks>{{ $t('license.fields.radius') }} {{ geoFencingDisplay.radius }} {{ $t('license.fields.radiusKm') }}</NoLineBreaks>
	</div>
</template>

<script>
import { computed, toRef } from 'vue';

import Utils from '@/api/Utils';

import NoLineBreaks from '@/components/common/NoLineBreaks';

export default {
	components: {
		NoLineBreaks,
	},
	props: ['geoFencing'],
	setup(props) {
		const geoFencingRef = toRef(props, 'geoFencing');
		const geoFencingDisplay = computed(() => {
			if (geoFencingRef.value == null) {
				return {};
			}
			return {
				bCoord: Utils.formatLatLong(geoFencingRef.value['b_coord']),
				lCoord: Utils.formatLatLong(geoFencingRef.value['l_coord']),
				radius: Utils.formatLatLong(geoFencingRef.value['radius']),
			}
		});
		return {
			geoFencingRef,
			geoFencingDisplay,
		};
	},
}
</script>